import { RefObject, useEffect } from 'react';

export function useHubSpotFullWidth(
	containerRef: RefObject<HTMLDivElement>,
	formHtmlCode: string,
	inputFullWidth: boolean | undefined,
	isMounted: boolean,
) {
	useEffect(() => {
		if (!containerRef.current || !isMounted) return;

		const container = containerRef.current;

		function applyFullWidthClasses() {
			const form = container.querySelector('form');
			if (!form) return;

			form.querySelectorAll('.hsfc-Field:not(.hsfc-CheckboxFieldGroup)').forEach((field) => {
				field.classList.toggle('hsfc-Field___fullWidth', !!inputFullWidth);
			});
		}

		applyFullWidthClasses();

		const observer = new MutationObserver((mutations) => {
			for (const mutation of mutations) {
				mutation.addedNodes.forEach((node) => {
					if (node.nodeType !== 1) return;
					const element = node as HTMLElement;
					if (element.matches('.hsfc-Field:not(.hsfc-CheckboxFieldGroup)') && inputFullWidth) {
						element.classList.add('hsfc-Field___fullWidth');
					}
					element.querySelectorAll('.hsfc-Field:not(.hsfc-CheckboxFieldGroup)').forEach((field) => {
						if (inputFullWidth) field.classList.add('hsfc-Field___fullWidth');
					});
				});
			}
		});

		observer.observe(container, { childList: true, subtree: true });
		return () => observer.disconnect();
	}, [formHtmlCode, inputFullWidth, isMounted]);
}
